import vaccineTemplateService from "../../api/vaccine-template.service";

const state = {};

const getters = {};

const actions = {
	async getTemplates({ rootState }) {
		const { authToken } = rootState.auth;
		const response = await vaccineTemplateService.getVaccineTemplates(
			authToken
		);
		return response;
	},

	async getSuppliers({ rootState }, type) {
		const { authToken } = rootState.auth;
		const response = await vaccineTemplateService.getSuppliers(
			authToken,
			type
		);
		return response;
	},

	async getTemplateById({ rootState }, id) {
		const { authToken } = rootState.auth;
		const response = await vaccineTemplateService.getVaccineTemplateById(
			authToken,
			id
		);
		return response;
	},

	async getProducts({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await vaccineTemplateService.getProducts(
			authToken,
			request_data
		);
		return response;
	},

	async addVaccineTemplate({ rootState }, request) {
		const { authToken } = rootState.auth;
		const response = await vaccineTemplateService.addVaccineTemplate(
			authToken,
			request
		);
		return response;
	},

	async addVaccine({ rootState }, request) {
		const { authToken } = rootState.auth;
		const response = await vaccineTemplateService.addVaccine(
			authToken,
			request
		);
		return response;
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
